import React from 'react'

export const TopNavButtonsWrapperUnstyled = props => (
  <div className={props.className}>
    <div className="opacity-background" />
    <ul>{props.children}</ul>
  </div>
)



// WEBPACK FOOTER //
// ./src/Components/Header/TopNavButtonsWrapper/unstyled.js